import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import image from '../images/dynamite.gif';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'left',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    maxWidth: "500px;",
  },
  subheader: {
  },
});

const tileData = [
  {
    img: image,
    title: 'Dynamite 001',
    cols: 1,
    ct: {
      webkitFilter: 'grayscale(100%)',
      filter: 'grayscale(100%)',
    },
  },
  {
    img: image,
    title: 'Dynamite 002',
    cols: 1,
    ct: {
      webkitFilter: 'contrast(150%) sepia(100%)',
      filter: 'contrast(150%) sepia(100%)',
    },
  },
  {
    img: image,
    title: 'Dynamite 003',
    cols: 1,
    ct: {
      webkitFilter: 'brightness(0.30) hue-rotate(180deg) saturate(7)',
      filter: 'brightness(0.30) hue-rotate(180deg) saturate(7)',
    },
  },
  {
    img: image,
    title: 'Dynamite 004',
    cols: 1,
    ct: {
      webkitFilter: 'saturate(5) sepia(30%)',
      filter: 'saturate(5) sepia(30%)',
    },
  },
  {
    img: image,
    title: 'Dynamite 005',
    cols: 1,
    ct: {
      webkitFilter: 'opacity(50%)',
      filter: 'opacity(50%)',
    },
  },
  {
    img: image,
    title: 'Dynamite 006',
    cols: 1,
    ct: {
      webkitFilter: 'invert(80%)',
      filter: 'invert(80%)',
    },
  },
];

class ColorTransform extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <h4>Color Transform</h4>
        <p>Demonstration of a simple grid layout and taking an image applying a variety of transforms on the image.</p>
        <div className={classes.root}>
          <GridList cellHeight={160} className={classes.gridList} cols={3}>
            {tileData.map(tile => (
              <GridListTile key={tile.img} cols={tile.cols || 1}>
                <img style={tile.ct} src={tile.img} title={tile.title} alt={tile.title} />
              </GridListTile>
            ))}
          </GridList>
        </div>
        <p>&nbsp;</p>
      </div>
    );
  }
}

ColorTransform.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ColorTransform);


// WEBPACK FOOTER //
// ./src/components/ColorTransform.js